import React from 'react';

import { Header, Navbar } from '@C';
import ErrorBoundary from '@C/Error';
import { RouteSetup } from '@C/TallyExport';

const TallyExport = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="Tally Export" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> Tally Export</h1>
            </div>
            <ErrorBoundary>
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { TallyExport };
